<template>
  <div class="content">
      <div class="block block-rounded block-fx-shadow mb-3">
        <div class="block-header">
          <h3 class="block-title">{{ $t('teams.index') }}</h3>
          <div class="block-options">
            <b-btn v-b-modal.addteam size="sm" variant="primary" class="float-right">{{ $t('teams.add') }}</b-btn>
          </div>
        </div>
        <div class="table-responsive-xl">
          <table class="table table-bordered  table-hover display">
            <thead>
              <tr>
                <th>#</th>
                <th>{{ $t('app.id') }}</th>
                <th>{{ $t('app.display_name') }}</th>
                <th>{{ $t('app.name') }}</th>
                <th>{{ $t('app.desc') }}</th>
                <th>{{ $t('teams.leader') }}</th>
                <th>{{ $t('app.action') }}</th>
              </tr>
            </thead>
            <tbody>
                <tr v-for="(team, index) in teams">
                  <td>{{index+1}}</td>
                  <td>{{team.id}}</td>
                  <td>{{team.display_name}}</td>
                  <td>{{team.name}}</td>
                  <td>{{team.description}}</td>
                  <td>{{team.leader ? team.leader.lastname: '' }} {{team.leader ? team.leader.firstname: '' }}</td>
                  <td>
                    <div class="btn-group" role="group" aria-label="btnGroup1">
                      <button @click.prevent="initUpdate(index)" class="btn btn-primary btn-sm" title="Редактировать">
                        <i class="fa fa-edit"></i>
                      </button>
                      <button @click.prevent="handleDelete(team.id)" class="btn btn-danger btn-sm " :disabled="isProcessing" title="Удалить">
                        <i class="fa fa-times-circle"></i>
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="loadRoles">
                  <td colspan="7" class="text-center">
                    <loader-wave/>
                  </td>
                </tr>
            </tbody>
          </table>
        </div>
      </div><!-- end card-->

      <b-modal size="lg" :title="$t('teams.edit')" ref="modalUpdateTeam" @ok="handleUpdate" @shown="fetchTeams" :ok-title="$t('buttons.save')" :cancel-title="$t('buttons.cancel')" @ok-disabled="isProcessing">
          <div class="form-group">
              <label for="UpdateName" class="col-form-label">{{ $t('app.name') }}</label>
              <input type="text" class="form-control" v-model="update_team.name" :class="{'is-invalid': update_errors.name }" id="UpdateName">
              <span v-if="update_errors.name" class="invalid-feedback">
                  <strong>{{update_errors.name ? update_errors.name[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label for="updatedisplayname" class="col-form-label">{{ $t('app.display_name') }}</label>
              <input type="text" class="form-control" v-model="update_team.display_name" :class="{'is-invalid': update_errors.display_name }" id="updatedisplayname">
              <span v-if="update_errors.display_name" class="invalid-feedback">
                  <strong>{{update_errors.display_name ? update_errors.display_name[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label class="col-form-label">{{ $t('teams.leader') }}</label>
              <select class="form-control" v-model="update_team.leader_id">
                <option selected="true" value="">{{ $t('field.any') }}</option>
                <option v-for="user in users" :value="user.id">
                  {{ user.lastname }} {{ user.firstname }}
                </option>
              </select>
          </div>
          <div class="form-group">
              <label for="updatedescription" class="col-form-label">{{ $t('app.desc') }}</label>
              <input type="text" class="form-control" v-model="update_team.description" :class="{'is-invalid': update_errors.description }" id="updatedescription">
              <span v-if="update_errors.description" class="invalid-feedback">
                  <strong>{{update_errors.description ? update_errors.description[0] : '' }}</strong>
              </span>
          </div>
      </b-modal>

      <b-modal id="addteam" size="lg" :title="$t('teams.add')" ref="modalAddTeam" @ok="handleStore" @shown="fetchTeams" :ok-title="$t('buttons.ok')" :cancel-title="$t('buttons.cancel')" @ok-disabled="isProcessing">
          <div class="form-group">
              <label for="storeName" class="col-form-label">{{ $t('app.name') }}</label>
              <input type="text" class="form-control" v-model="team.name" :class="{'is-invalid': errors.name }" id="storeName">
              <span v-if="errors.name" class="invalid-feedback">
                  <strong>{{errors.name ? errors.name[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label for="storeDisplayName" class="col-form-label">{{ $t('app.display_name') }}</label>
              <input type="text" class="form-control" v-model="team.display_name" :class="{'is-invalid': errors.display_name }" id="storeDisplayName">
              <span v-if="errors.display_name" class="invalid-feedback">
                  <strong>{{errors.display_name ? errors.display_name[0] : '' }}</strong>
              </span>
          </div>
          <div class="form-group">
              <label class="col-form-label">{{ $t('teams.leader') }}</label>
              <select class="form-control" v-model="team.leader_id">
                <option selected="true" value="">{{ $t('field.any') }}</option>
                <option v-for="user in users" :value="user.id">
                  {{ user.lastname }} {{ user.firstname }}
                </option>
              </select>
          </div>
          <div class="form-group">
              <label for="storeDescription" class="col-form-label">{{ $t('app.desc') }}</label>
              <input type="text" class="form-control" v-model="team.description" :class="{'is-invalid': errors.description }" id="storeDescription">
              <span v-if="errors.description" class="invalid-feedback">
                  <strong>{{errors.description ? errors.description[0] : '' }}</strong>
              </span>
          </div>
      </b-modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      roles: [],
      teams: [],
      users: [],
      team: {
        name: '',
        leader_id: '',
        display_name: '',
        description: '',
      },
      errors: {},
      update_errors: {},
      update_team: {},
      isProcessing: false,
      loadRoles: false,
    };
  },
  mounted() {
    this.fetchTeams();
    this.getListUsers();
  },
  methods: {
    fetchTeams() {
      window.axios.get('/admin/teams')
        .then((res) => {
          this.teams = res.data.teams;
        });
    },

    getListUsers() {
      window.axios.get('/admin/list/users')
        .then((res) => {
          this.users = res.data.users;
        });
    },

    clearModal() {
      this.team.name = '';
      this.team.leader_id = '';
      this.team.display_name = '';
      this.team.description = '';
    },

    clearUpdateModal() {
      this.update_team = {};
    },

    initUpdate(index) {
      this.update_errors = {};
      this.update_team = this.teams[index];
      this.$refs.modalUpdateTeam.show();
    },

    handleStore(evt) {
      evt.preventDefault();
      this.isProcessing = true;
      this.storeTeam();
    },

    handleUpdate(evt) {
      evt.preventDefault();
      this.isProcessing = true;
      this.updateTeam();
    },

    handleDelete(id) {
      window.Swal.fire({
        title: this.$t('alerts.are_you_sure'),
        text: this.$t('alerts.want_to_delete'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('alerts.delete_it'),
        cancelButtonText: this.$t('field.cancel'),
      }).then((result) => {
        if (result.value) {
          this.deleteTeam(id);
        }
      });
    },

    storeTeam() {
      window.axios.post('/admin/teams', this.team)
        .then((res) => {
          if (res.status === 201) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.$refs.modalAddTeam.hide();
            this.clearModal();
            this.fetchTeams();
          }
        })
        .catch((err) => {
          this.errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    updateTeam() {
      window.axios.put(`/admin/teams/${this.update_team.id}`, this.update_team)
        .then((res) => {
          if (res.status === 200) {
            this.$refs.modalUpdateTeam.hide();
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.clearUpdateModal();
            this.fetchTeams();
          }
        })
        .catch((err) => {
          this.update_errors = this.laravelValidation(err);
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },

    deleteTeam(id) {
      this.isProcessing = true;
      window.axios.delete(`/admin/teams/${id}`)
        .then((res) => {
          if (res.status === 204) {
            window.Swal.fire(this.$t('alerts.success'), res.data.message, 'success');
            this.fetchTeams();
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
  },
};
</script>
